module.exports = __webpack_public_path__ + "79b16e3c9d6a7f765c88d908867f38ac.png";